import {EqualGridItemProps} from "./EqualGridItem";
import {Card, CardContent} from "@mui/material";
import React from "react";

export function BasicCard({children}: EqualGridItemProps) {
    return <Card>
        <CardContent>
            {children}
        </CardContent>
    </Card>
}